
<div class="w-full h-full min-w-[1366px] ">
  <router-outlet></router-outlet>
</div>
<p-toast key="toast"></p-toast>
